/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reduxModulesAbout = require('redux/modules/about');

var About = (function (_Component) {
	_inherits(About, _Component);

	function About() {
		_classCallCheck(this, _About);

		_Component.apply(this, arguments);
	}

	About.fetchData = function fetchData(getState, dispatch) {
		var promises = [];

		if (!_reduxModulesAbout.isLoaded(getState())) {
			promises.push(dispatch(_reduxModulesAbout.load()));
		}

		return _Promise.all(promises);
	};

	About.prototype.render = function render() {
		var _classNames;

		var styles = require('./About.css');
		var about = this.props.about;

		var contentStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Content] = true, _classNames.CMSContent = true, _classNames));

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: about.title }),
			_react2['default'].createElement(
				'article',
				{ className: styles.Article },
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'h1',
						null,
						'About Us'
					)
				),
				_react2['default'].createElement('div', { className: contentStyles, dangerouslySetInnerHTML: { __html: about.post_content } })
			)
		);
	};

	_createClass(About, null, [{
		key: 'propTypes',
		value: {
			about: _react.PropTypes.object,
			aboutError: _react.PropTypes.string,
			aboutLoading: _react.PropTypes.bool,
			location: _react.PropTypes.object
		},
		enumerable: true
	}]);

	var _About = About;
	About = _reactRedux.connect(function (state) {
		return {
			about: state.about.data,
			aboutError: state.about.error,
			aboutLoading: state.about.loading
		};
	})(About) || About;
	return About;
})(_react.Component);

exports['default'] = About;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/About/About.js
 ** module id = 697
 ** module chunks = 0
 **/